// apps/admin-ui/src/components/sidebars/sidebarStyles.ts
export const sidebarItemClass = (isActive: boolean) =>
  `flex items-center gap-2.5 px-3 py-1.5 rounded-md text-sm font-medium transition-colors w-full ${
    isActive
      ? 'bg-zinc-100 text-zinc-900'
      : 'text-zinc-500 hover:bg-zinc-50 hover:text-zinc-800'
  }`;

export const sidebarSubItemClass = (isActive: boolean) =>
  `flex items-center gap-2.5 pl-7 pr-3 py-1.5 rounded-md text-sm font-medium transition-colors w-full ${
    isActive
      ? 'bg-zinc-100 text-zinc-900'
      : 'text-zinc-400 hover:bg-zinc-50 hover:text-zinc-700'
  }`;

export const sidebarSectionLabelClass =
  'text-[10px] font-semibold text-zinc-400 uppercase tracking-wider px-3 mt-4 mb-1 block';
